"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _allTemplates = require("../../../allTemplates.js");
var _DataConnectorsPicker = _interopRequireDefault(require("../../DataConnectorsPicker"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Settings = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(Settings, _React$Component);
  function Settings() {
    var _this;
    _classCallCheck(this, Settings);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Settings, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_getChildren", function () {
      var id = _this.props.currentElement.id;
      var elements = _this.props.elements;
      if (!elements[id].children) {
        return [];
      }
      return elements[id].children.map(function (child) {
        return elements[child];
      });
    });
    return _this;
  }
  _createClass(Settings, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        elementTypes = _this$props.elementTypes,
        currentElement = _this$props.currentElement,
        updateCurrentElementSettings = _this$props.updateCurrentElementSettings,
        getDataConnectorMeta = _this$props.getDataConnectorMeta,
        currentPlayerTemplateName = _this$props.currentPlayerTemplateName,
        currentPlayerTemplateSettings = _this$props.currentPlayerTemplateSettings,
        dynamicUserLists = _this$props.dynamicUserLists,
        defaultValues = _this$props.defaultValues,
        showAdvancedSettings = _this$props.showAdvancedSettings,
        restrictionsLevel = _this$props.restrictionsLevel,
        flowSettings = _this$props.flowSettings;
      if ((0, _isEmpty2["default"])(currentElement)) {
        return null;
      }
      var elementType = (0, _find2["default"])(elementTypes, {
        code: currentElement.type
      });
      var Builder = elementType ? elementType.builder : null;
      if (!elementType || !Builder) {
        return null;
      }
      var initialValues = _objectSpread(_objectSpread({}, elementType.builderInitialValues), currentElement.settings);
      var DataConnectorsPickerAdjusted = (0, _cccisdSurveyCommon.getComponentWithProps)(_DataConnectorsPicker["default"], {
        elementId: currentElement.id
      });
      var key = currentElement.id + '_' + currentElement.undoIterator;
      return /*#__PURE__*/_react["default"].createElement(Builder, {
        key: key,
        form: "builderForm_".concat(key),
        initialValues: initialValues,
        elementType: elementType,
        updatePreview: updateCurrentElementSettings,
        showPreviewError: function showPreviewError() {},
        availableTemplates: (0, _allTemplates.getTemplateList)('components', currentElement.type),
        availableComponentTemplates: (0, _allTemplates.getTemplatesForGroup)('components'),
        availablePlayerTemplates: (0, _allTemplates.getTemplateList)('players', 'flow'),
        currentPlayerTemplateName: currentPlayerTemplateName,
        currentPlayerTemplateSettings: currentPlayerTemplateSettings,
        children: this._getChildren(),
        DataConnectorsPicker: DataConnectorsPickerAdjusted,
        getDataConnectorMeta: getDataConnectorMeta,
        dynamicUserLists: dynamicUserLists,
        defaultValues: defaultValues,
        showAdvancedSettings: showAdvancedSettings,
        isTopLevel: currentElement.isTopLevel,
        restrictionsLevel: restrictionsLevel,
        flowSettings: flowSettings
      });
    }
  }]);
  return Settings;
}(_react["default"].Component);
_defineProperty(Settings, "propTypes", {
  elements: _propTypes["default"].object,
  elementTypes: _propTypes["default"].array,
  currentElement: _propTypes["default"].object,
  updateCurrentElementSettings: _propTypes["default"].func,
  getDataConnectorMeta: _propTypes["default"].func,
  currentPlayerTemplateName: _propTypes["default"].string,
  currentPlayerTemplateSettings: _propTypes["default"].object,
  dynamicUserLists: _propTypes["default"].array,
  defaultValues: _propTypes["default"].array,
  showAdvancedSettings: _propTypes["default"].bool,
  restrictionsLevel: _propTypes["default"].string,
  flowSettings: _propTypes["default"].object
});